export const formatUrl = (url, includeDomain = false, filterUUID = true) => {
	if (!url) {
		return '';
	}

	const prefix = includeDomain ? process.env.GATSBY_DOMAIN_URL : '';

	// Remove trailing slashes
	let urlPaths = url.replace(/\/+$/, '').split('/');

	if (filterUUID) {
		urlPaths = urlPaths.filter(pathPartial => !pathPartial.startsWith('-'));
	}
	if (urlPaths[0] !== '') {
		urlPaths.unshift('');
	}

	return `${prefix}${urlPaths.join('/')}`;
};

export const LibraryPages = {
	LANDING: 'LANDING',
	CATEGORY: 'CATEGORY',
	ITEM: 'ITEM',
	ALL_CONTENT: 'ALL_CONTENT',
	ALL_TOOLS: 'ALL_TOOLS',
	ALL_LESSONS: 'ALL_LESSONS',
};

export const getLibraryUrlPrefix = (locale, t, page, lng) => {
	const lngOptions = lng ? { lng } : {};

	if (lng && lng === 'nl') {
		// NL translations are split between nl-nl and nl-be
		// use locale instead of lng for NL translations
		lngOptions.lng = locale;
	}

	const urlParts = [locale, t('gynzy-library-url-structure.library', lngOptions)];

	switch (page) {
		case LibraryPages.LANDING:
		case LibraryPages.CATEGORY:
			break;
		case LibraryPages.ITEM:
		case LibraryPages.ALL_CONTENT:
			urlParts.push(t('gynzy-library-url-structure.items', lngOptions));
			break;
		case LibraryPages.ALL_TOOLS:
			urlParts.push(t('gynzy-library-url-structure.tools', lngOptions));
			break;
		case LibraryPages.ALL_LESSONS:
			urlParts.push(t('gynzy-library-url-structure.lessons', lngOptions));
			break;
		default:
			break;
	}

	return urlParts.join('/');
};
